import { ReactSelectOption } from "../generic";

export interface Tag {
    id: number;
    name: string;
}

export const tagToReactSelectOption = (t: Tag): ReactSelectOption => ({
    label: t.name,
    value: t.id,
});



// WEBPACK FOOTER //
// ./src/models/tag/Tag.ts